function toggleRangeBox(collections, show) {
    var range_box = collections.querySelector('.range-listing__box');
    var range_close = collections.querySelector('.range-listing__close');
    if (show) {
        range_box.classList.add('range-listing__box--show');
        range_box.setAttribute('aria-expanded', 'true');
        range_close.classList.add('range-listing__close--show');
        range_close.removeAttribute('aria-hidden');
        range_close.focus();
    } else {
        range_box.classList.remove('range-listing__box--show');
        range_box.setAttribute('aria-expanded', 'false');
        range_close.classList.remove('range-listing__close--show');
        range_close.setAttribute('aria-hidden', 'true');
    }
}

// Open box on view button click
var range_view = document.querySelectorAll('.range-listing__view');
range_view.forEach(function (button) {
    button.addEventListener('click', function () {
        var collections = this.closest('.range-listing__collections');
        toggleRangeBox(collections, true);
    });
});

// Close box on close button click
var range_close_btns = document.querySelectorAll('.range-listing__close');
range_close_btns.forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
        var collections = this.closest('.range-listing__collections');
        toggleRangeBox(collections, false);
    });
});

